import {dataURItoFile, resizeImage} from "./imageProcessing";
import {cynoEncryptionKey} from './database/database-utils';

var randomstring = require("randomstring");
var CryptoJS = require("crypto-js");

export const encryptedKeyGenerator = (randomKey = null) => {
    if(randomKey == null)
        randomKey = randomstring.generate(32);
    return CryptoJS.AES.encrypt(randomKey, cynoEncryptionKey).toString();
};

/**
 * Converts a word array to a Uint8Array.
 * @param {WordArray} wordArray The word array.
 * @return {Uint8Array} The Uint8Array.
 * @static
 */
export const getUnsigned8Array = (wordArray) => {
    let words = wordArray.words;
    const sigBytes = wordArray.sigBytes;
    // Convert
    let unsigned8Array = new Uint8Array(sigBytes);
    for (let i = 0; i < sigBytes; i++)
        unsigned8Array[i] = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
    return unsigned8Array;
};

export const decryptMessages = async (messageArray , encryptedKey) => {
    let msgArray = [];
    // console.log('messageArray @ decryptMessages:', messageArray);
    // console.log('encryptedKey @ decryptMessages:', encryptedKey);
    if(encryptedKey){
        try{
            const plainKey = getEncryptionKey(encryptedKey);
            // console.log('plainText (Key) @decryptMessages:', plainKey);

            let msgArray = null;
            await Promise.all(messageArray.map(async (message) => {
                let msgObj = {...message};
                if(!msgObj.state && msgObj.state !== 'plain') {
                    if(msgObj.photoURL) {
                        let plainName = randomstring.generate(10)+'.jpg';
                        await fetchDecryptedImageURL(msgObj.photoURL, plainName, plainKey/*plainKey*/)
                            .then((plainPhotoURL) => {
                                // console.log('new URL: ', plainPhotoURL);
                                msgObj.photoURL = plainPhotoURL;
                            });
                    }
                    if(msgObj.mealDescription){
                        let description = '';
                        let title = '';
                        try {
                            msgObj.mealDescription && (description = CryptoJS.AES.decrypt(msgObj.mealDescription, plainKey).toString(CryptoJS.enc.Utf8));
                            msgObj.mealTitle && (title = CryptoJS.AES.decrypt(msgObj.mealTitle, plainKey).toString(CryptoJS.enc.Utf8));
                            if (description.length !== 0 || title.length !== 0) {
                                msgObj.mealDescription = description;
                                msgObj.mealTitle = title;
                                msgObj.state = 'plain';
                            } else {
                                msgObj.mealDescription = message.mealDescription;
                                msgObj.mealTitle = message.mealTitle;
                            }
                        } catch (e) {
                            msgObj.mealDescription = message.mealDescription;
                            msgObj.mealTitle = message.mealTitle;
                            console.log('CATCHING', e);
                        }
                        // console.log('msgObj @ end @ dec: ', msgObj);
                    }
                    else if(msgObj.text) {
                        let plaintext = '';
                        try {
                            plaintext = CryptoJS.AES.decrypt(msgObj.text, plainKey).toString(CryptoJS.enc.Utf8);
                            // console.log('plaintext2 @decryptMessages:', plainKey);
                        } catch (e) {
                            msgObj.text = message.text;
                            console.log('CATCHING', e);
                        }
                        if (plaintext.length !== 0) {
                            msgObj.text = plaintext;
                            msgObj.state = 'plain';
                        } else {
                            msgObj.text = message.text;
                        }
                    }
                }
                return msgObj;
            }))
            .then(values => {
                msgArray = values;
            });
            // console.log('All messages:', msgArray);
            return msgArray;

        }catch(e){
            console.log(e);
        }
    }else{
        msgArray = messageArray.map((msg)=>{
            let msgObj = {...msg};
            msgObj.text = msg.text;
            return msgObj;
        });
        return msgArray;
    }
};

export const fetchDecryptedImageURL = (url, name, password) => {
    return new Promise((resolve, reject) => {
        fetch(url)
            .then(processStatus)
            .then(decryptBlob.bind(null, password))
            .then(response => {
                // console.log('@third then @ fetchDecryptedImageURL: ', response);
                resolve(URL.createObjectURL(response));
            });
    });
};

const processStatus = (response) => {// process status
    return new Promise((resolve,reject) => {
        if (response.status === 200) {
            return resolve(response.blob());
        } else {
            return reject(new Error('Error loading: ' + url))
        }
    });
};

const decryptBlob = (password, blob) => {
    return new Promise((resolve, reject)=> {
        // console.log('response @ decryptBlob: ', blob);
        const reader = new FileReader();
        reader.onload = (event) => {
            // console.log('Encrypted String:', event.target.result);
            const decrypted = CryptoJS.AES.decrypt(event.target.result, password);
            // console.log('Decrypted WordArray:', decrypted.sigBytes);
            const decryptedArray = getUnsigned8Array(decrypted);
            // console.log('decrypted Array:', decryptedArray.length);
            resolve(new Blob([decryptedArray]));
        };
        reader.readAsText(blob);
    }).catch((error) => {
        console.log('error in file decryption:', error);
    })
};

export const fileEncryption = (key, file) => {
    const reader = new FileReader();
    // console.log('file:', file);
    // console.log('key:', key);

    return new Promise(function (resolve, reject) {
        reader.onload = (event) => {
            // console.log('Base ArrayBuffer:', event.target.result);

            const imageWordArray = CryptoJS.lib.WordArray.create(event.target.result);
            // console.log('WordArray before encryption:', imageWordArray);
            const encrypted = CryptoJS.AES.encrypt(imageWordArray, key);
            // console.log('Encrypted WordArray:', encrypted);
            const encryptedString = encrypted.toString();
            // console.log('encryptedString:', encryptedString);
            const encFile = new File([encryptedString], file.name+'.enc');
            // console.log('Enc file:', encFile);
            resolve(encFile);
        };
        reader.readAsArrayBuffer(file);
    })
};

export const getEncryptionKey = (encryptedKey) => {
    return CryptoJS.AES.decrypt(encryptedKey, cynoEncryptionKey).toString(CryptoJS.enc.Utf8);
};

export const encryptMessage = (encryptedKey, messageText, photoFile, messageTitle = null) => {
    // let encMessage =null;
    let encFile = null;
    // let encTitle = null;
    const plainKey = CryptoJS.AES.decrypt(encryptedKey, cynoEncryptionKey).toString(CryptoJS.enc.Utf8);
    const encMessage = CryptoJS.AES.encrypt(messageText, plainKey).toString();
    const encTitle = messageTitle && CryptoJS.AES.encrypt(messageTitle, plainKey).toString();

    return resizeImage(photoFile, 1024)
        .then( processedImageData => {
            // console.log("upload processedImageData data: ", processedImageData);
            let processedImageFile = dataURItoFile(processedImageData, photoFile.name);
            // console.log("upload processedImageData blob: ", processedImageFile);
            return Promise.resolve(processedImageFile);
        })
        .then(processedImageFile => {
            return fileEncryption(plainKey, processedImageFile)
                .then (response => {encFile = response});
        }, rejected => {
            // console.log('rejected @ encryptMessage => no image', rejected);
        })
        .then(()=>{
            // console.log('plainKey:', plainKey);
            // console.log('encMessage:', encMessage);
            // console.log('encFile:', encFile);
            if(messageTitle)
                return {encMessage: encMessage, encFile: encFile, encTitle: encTitle};
            else
                return {encMessage: encMessage, encFile: encFile};
        })
        .catch( err => console.error(err));
};





// WEBPACK FOOTER //
// ./src/js/utils/security.js